var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_387_2415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 47C17.2674 47 11.2901 44.5241 6.88299 40.117C2.47588 35.7099 0 29.7326 0 23.5C0 17.2674 2.47588 11.2901 6.88299 6.88299C11.2901 2.47589 17.2674 0 23.5 0C29.7326 0 35.7099 2.47589 40.117 6.88299C44.5241 11.2901 47 17.2674 47 23.5C47 29.7326 44.5241 35.7099 40.117 40.117C35.7099 44.5241 29.7326 47 23.5 47ZM32.3768 35.6814C32.6154 36.4525 33.4416 36.8932 34.2127 36.6453C34.9838 36.3975 35.4244 35.5805 35.1766 34.8094C33.6711 29.935 28.9803 26.4375 23.5 26.4375C18.0197 26.4375 13.3289 29.935 11.8143 34.8186C11.5756 35.5896 12.007 36.4158 12.7781 36.6545C13.5492 36.8932 14.3754 36.4617 14.6141 35.6906C15.7432 32.0738 19.2682 29.375 23.5 29.375C27.7318 29.375 31.2568 32.0738 32.3768 35.6814ZM33.7445 19.0938C33.7445 18.3147 33.435 17.5675 32.8842 17.0166C32.3333 16.4657 31.5861 16.1562 30.807 16.1562C30.028 16.1562 29.2808 16.4657 28.7299 17.0166C28.179 17.5675 27.8695 18.3147 27.8695 19.0938C27.8695 19.8728 28.179 20.62 28.7299 21.1709C29.2808 21.7218 30.028 22.0312 30.807 22.0312C31.5861 22.0312 32.3333 21.7218 32.8842 21.1709C33.435 20.62 33.7445 19.8728 33.7445 19.0938ZM16.1195 16.1562C15.3405 16.1562 14.5933 16.4657 14.0424 17.0166C13.4915 17.5675 13.182 18.3147 13.182 19.0938C13.182 19.8728 13.4915 20.62 14.0424 21.1709C14.5933 21.7218 15.3405 22.0312 16.1195 22.0312C16.8986 22.0312 17.6458 21.7218 18.1967 21.1709C18.7475 20.62 19.057 19.8728 19.057 19.0938C19.057 18.3147 18.7475 17.5675 18.1967 17.0166C17.6458 16.4657 16.8986 16.1562 16.1195 16.1562Z",
    fill: "#E5004E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_387_2415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "matrix(-1 0 0 1 47 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.697d632fb52581134eaeb20e91d1a0a3.svg";
export { ForwardRef as ReactComponent };